import BlTabContentMv from './BlTabContentMv.vue'

BlTabContentMv.install = function(Vue) {
  Vue.component(BlTabContentMv.name, BlTabContentMv)
}

export default BlTabContentMv
